<template>
  <a-layout id="components-layout-demo-custom-trigger" style="height: 100vh">
    <a-layout-sider
      v-model="collapsed"
      :trigger="null"
      collapsible
      theme="light"
      style="background: #eef2f8"
    >
      <div class="layout-logo" @click="JumpToMain">
        <div class="logo-icon">居</div>
        <div v-show="!collapsed" class="logo-text">居里e装</div>
      </div>
      <!-- <side-menu></side-menu> -->
      <Sidebar />
      <div class="div-trigger">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="() => (collapsed = !collapsed)"
        />
      </div>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="main-header" style="background: #fff">
        <!-- top -->
        <breadcrumb />
      </a-layout-header>
      <a-layout-content class="main-content">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import SideMenu from "./SideMenu.vue";
import Breadcrumb from "./Breadcrumb.vue";
import Sidebar from "./Sidebar";
export default {
  components: { SideMenu, Breadcrumb, Sidebar },
  data() {
    return {
      collapsed: false,
      rootSubmenuKeys: ["sub1", "sub2", "sub4"],
      openKeys: ["sub1"],
      systemName: "",
    };
  },
  created() {},
  watch: {
    "$store.state.user.system": {
      handler(newValue) {
        // console.log("$store.state.user.system", newValue);
        if (newValue == "xc") {
          this.systemName = "现场管理系统";
        } else if (newValue == "jf") {
          this.systemName = "交付系统";
        } else if (newValue == "yx") {
          this.systemName = "营销系统";
        }
      },
      immediate: true,
    },
  },
  methods: {
    JumpToMain() {
      // this.$router.push({ path: "/" });
      this.$router.push({ path: "/Login" });
    },
  },
};
</script>
<style lang="less">
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .layout-logo {
  margin: 24px 0 20px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #34333b;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.logo-icon {
  width: 32px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}
.logo-text {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
/deep/.layout-logo {
  overflow: visible !important;
}
#components-layout-demo-custom-trigger .div-trigger {
  /* width: 100%; */
  position: absolute;
  bottom: 0;
}
.main-header {
  background: #fff;
  padding: 0;
  text-align: left;
}
.main-content {
  padding: 0 16px;
  background: #fff;
  min-height: 280px;
  height: 100%;
  overflow: auto;
}
.ant-layout-sider-children {
  /* overflow: auto; */
  // overflow: hidden;
}
</style>
